import React, { useEffect } from "react";
import getUserInterrations from "./apis/getUserInterrations";
import {
  CartesianGrid,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
  Line,
  LineChart,
} from "recharts";

// Format date labels (e.g., 12 May)
const formatDate = (isoDate) => {
  const d = new Date(isoDate);
  return d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
  });
};

const UserInteractionLineChart = ({
  botId,
  start,
  end,
  state,
  dispatch,
  period = 30,
}) => {
  useEffect(() => {
    const fetchData = async () => {
      const res = await getUserInterrations(botId, start, end, period);
      if (!res.error && res.data?.chart_data) {
        // Transform chart data to format recharts expects
        const formattedData = res.data.chart_data.map((item) => ({
          date: formatDate(item.date),
          total_hits: item.total_hits,
        }));

        dispatch({
          type: "SET_USER_INTERACTION_DATA",
          payload: formattedData,
        });
      } else {
        console.error("Chart API Error:", res.msg || res.error);
      }
    };

    if (botId) {
      fetchData();
    }
  }, [botId, start, end, period, dispatch]);

  return (
    <div className="w-full h-96">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={state.userInterrationLineChart}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Line
            type="monotone"
            dataKey="total_hits"
            stroke="#8884d8"
            strokeWidth={2}
            dot={{ r: 4 }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default UserInteractionLineChart;
